import React from 'react';

import Box from '@mui/material/Box';

import NotificationPermissionDialog from 'components/NotificationPermissionDialog';
import { drawerWidth, drawerWidthMD, drawerWidthCollapsed } from 'components/layout/SideBar';
import { MOBILE_TOP_BAR_HEIGHT } from 'components/layout/headers/MobileTopBar';

interface LayoutContentProps {
  children?: React.ReactNode;
  isFullWidthRoute: boolean;
  isMobile: boolean;
  isCollapsed: boolean;
}

const LayoutContent = ({ children = undefined, isFullWidthRoute, isMobile, isCollapsed }: LayoutContentProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 0%',
      minWidth: 0,
      height: isMobile ? '100svh' : undefined,
      boxSizing: isMobile ? 'border-box' : undefined,
      maxWidth: isMobile
        ? undefined
        : {
            xs: '100%',
            lg: isCollapsed ? `calc(100% - ${drawerWidthCollapsed}px)` : `calc(100% - ${drawerWidthMD}px)`,
            xl: isCollapsed ? `calc(100% - ${drawerWidthCollapsed}px)` : `calc(100% - ${drawerWidth}px)`,
          },
      width: {
        xs: '100%',
      },
      m: 0,
      p: 0,
      pt: isMobile ? `calc(${MOBILE_TOP_BAR_HEIGHT}px + env(safe-area-inset-top))` : 0,
      maxHeight: '100svh',
      overflow: 'auto',
    }}
  >
    <NotificationPermissionDialog />
    <Box
      sx={{
        backgroundColor: 'secondary.light',
        borderRadius: isMobile ? 0 : { xs: 0, lg: isFullWidthRoute ? 0 : '38px 0 0 30px' },
        height: isMobile ? '100%' : '100vh',
        width: '100%',
        px: isFullWidthRoute ? 0 : { xs: 0, lg: 3, xl: 6 },
        pt: 0,
        overflow: isFullWidthRoute ? 'hidden' : 'auto',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default LayoutContent;
